import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {PlinkoStageConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoStageConfig";
import {PlinkoSpringConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoSpringConfig";
import {PlinkoBallConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoBallConfig";
import {Schema} from "@/common/Schema";

export class PlinkoGameConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(PlinkoGameConfig, v) : SKIP;
        }, (v) => {
            return deserialize(PlinkoGameConfig, v);
        });
    }

    constructor() {
        super();

        this._currencyGear = null;

        this._ball = null;
        this._spring = null;
        this._stages = [];
        this._multipliers = [];
    }

    get currencyGear() {
        return this._currencyGear;
    }

    set currencyGear(value) {
        this._currencyGear = value;
    }

    get ball() {
        return this._ball;
    }

    set ball(value) {
        this._ball = value;
    }

    get spring() {
        return this._spring;
    }

    set spring(value) {
        this._spring = value;
    }

    get stages() {
        return this._stages;
    }

    set stages(value) {
        this._stages = value;
    }

    get multipliers() {
        return this._multipliers;
    }

    set multipliers(value) {
        this._multipliers = value;
    }

    get multipliersString() {
        if (this.multipliers) {
            return this.multipliers.join(";");
        }
        return "";
    }

    set multipliersString(value) {
        if (!value || value.length === 0) {
            this.multipliers = [];
        } else {
            this.multipliers = value.split(";").map(Number).filter(v => v > 0);
        }
    }

    valid() {

        if (!CurrencyKindModel.is(this.currencyGear)) {
            return false;
        }

        if (!this.ball || !this.ball.valid()) {
            return false;
        }

        if (!this.spring || !this.spring.valid()) {
            return false;
        }

        if (!this.stages || this.stages.length === 0) {
            return false;
        }

        if (this.stages.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.multipliers || this.multipliers.length === 0) {
            return false;
        }

        if (this.multipliers.some(v => !Number.isInteger(v) || v <= 0)) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.stages || this.stages.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PlinkoGameConfig());
        } else if (target instanceof PlinkoGameConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PlinkoGameConfig, {
    _currencyGear: alias("currency_gear", CurrencyKindModel.schema()),

    _ball: alias("ball", PlinkoBallConfig.schema()),
    _spring: alias("spring", PlinkoSpringConfig.schema()),
    _stages: alias("stages", list(PlinkoStageConfig.schema())),
    _multipliers: alias("multipliers", list(Schema.primitive())),
});